import  PartnerImage from './PartnerImage';
export default PartnerImage
